import { Col, Layout, Pagination, Row, Table } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../assets/images/ieat_logo.png";
import NotFound from "../../../components/common/notFound";
import { importFileFail } from "../../../services/importFileService";

const { Header } = Layout;

const ExportError = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [pageValues, setPageValues] = useState({
    page: 0,
    pageSize: 10,
    sortBy: "rowNo",
    sortDirection: "ASC",
  });

  const sessionId = location.pathname.replace("/import-error/", "");

  const columns = [
    {
      width: 300,
      align: "left",
      title: "แถว",
      dataIndex: "row",
      key: "row",
      render: (_, record) => <span>{record.row}</span>,
    },
    {
      width: 300,
      align: "left",
      title: "คอลัมน์",
      dataIndex: "column",
      key: "column",
      sorter: (a, b) => a.column - b.column,
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      key: "remark",
      sorter: (a, b) => a.remark - b.remark,
    },
  ];

  const uploadFail = useCallback(
    async (searchValues, pageValues) => {
      const res = await importFileFail(searchValues, pageValues);
      if (res?.data?.code === "0000") {
        const { objectValue, pageValue } = res.data;

        setDataSource(objectValue);

        setPageValues({
          page: parseInt(pageValue.page),
          pageSize: parseInt(pageValue.pageSize),
          total: parseInt(pageValue.total),
          totalPage: parseInt(pageValue.totalPage),
          sortBy: pageValue.sortBy,
          sortDirection: pageValue.sortDirection,
        });
      } else {
        setDataSource([]);
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
    [setPageValues]
  );

  const onSorter = (pagination, filters, sorter) => {
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "userId",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setLoading(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  useEffect(() => {
    uploadFail(sessionId, pageValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    uploadFail,
    sessionId,
    pageValues.page,
    pageValues.pageSize,
    pageValues.sortBy,
    pageValues.sortDirection,
  ]);

  return (
    <>
      <Header className="header topbar">
        <Link to={"/"} style={{ display: "flex", alignItems: "center" }}>
          <img src={Logo} width={50} height={50} alt="logo" />
        </Link>
      </Header>
      <div style={{ margin: "0px 10%" }}>
        <Row gutter={[24]}>
          <h2>รายละเอียดไฟล์นำเข้ามีข้อผิดพลาด</h2>
        </Row>
        <Row gutter={[24]}>
          <label>รายการทั้งหมด {pageValues?.total} รายการ</label>
        </Row>
        <Row gutter={[24]}>
          <Col span={24} align="right">
            <Table
              locale={{ emptyText: <NotFound /> }}
              loading={loading}
              rowKey={"key"}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              scroll={{
                x: 1300,
              }}
              onChange={onSorter}
            />
          </Col>
        </Row>
        <Row gutter={[24]}>
          <Col span={24} align="right">
            <Pagination
              showSizeChanger
              defaultCurrent={pageValues.page + 1 || 1}
              total={pageValues.total || 10}
              onChange={onPageChange}
              showTotal={(total) => `รวม ${total} รายการ`}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ExportError;
